














































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import hash from "object-hash";
import LoadErrorIcon from "vue-material-design-icons/AlertCircleOutline.vue";
import RefreshIcon from "vue-material-design-icons/Refresh.vue";
import ResetIcon from "vue-material-design-icons/CloseOctagon.vue";
import languageIcon from "@/shared/languageIcon";
import VulnerabilityType from "@/types/VulnerabilityType";
import LanguageDisplay from "@/components/LanguageDisplay.vue";

@Component({
  components: {
    LanguageDisplay,
    LoadErrorIcon,
    RefreshIcon,
    ResetIcon
  }
})
export default class VulnerabilityTranslate extends Vue {
  @Prop() private enVulnerability!: VulnerabilityType;
  @Prop() private langVulnerability!: VulnerabilityType;
  @Prop() private language!: string;
  @Prop() private loading!: boolean;
  @Prop() private branchNotFound!: boolean;

  private languageIcon = languageIcon;
  private isDirtyName = false;
  private isDirtyQuestion = false;
  private isDirtySummary = false;
  private isDirtyDescription = false;
  private isDirtyBusinessImplication = false;
  private isDirtyCompliant = false;
  private isDirtyNonCompliant = false;
  private isDirtySuccessMessage = false;
  private isDirtyRelatedTo = false;

  @Watch("$store.state.modifiedVulnerabilitiesCounter")
  private watchModifiedVulnerabilities() {
    this.checkDirtyFlags();
  }

  checkDirtyFlags() {
    this.setIsDirtyName();
    this.setIsDirtyQuestion();
    this.setIsDirtySummary();
    this.setIsDirtyDescription();
    this.setIsDirtyBusinessImplication();
    this.setIsDirtyCompliant();
    this.setIsDirtyNonCompliant();
    this.setIsDirtySuccessMessage();
    this.setIsDirtyRelatedTo();
  }

  modifiedVulnerability() {
    if (!this.language) {
      return;
    }
    if (!this.langVulnerability) {
      return;
    }
    const modifiedVulns = localStorage.getItem("modifiedVulnerabilities");
    if (!modifiedVulns) {
      return;
    }
    const mvs = JSON.parse(modifiedVulns);
    if (!mvs[this.language] || !Object.keys(mvs[this.language]).length) {
      return;
    }
    return mvs[this.language][this.langVulnerability.id].vulnerability;
  }

  setIsDirtyName() {
    const v = this.modifiedVulnerability();
    this.isDirtyName = !!(v && v.name && v.name.content);
  }

  setIsDirtyQuestion() {
    const v = this.modifiedVulnerability();
    this.isDirtyQuestion = !!(v && v.question && v.question.content);
  }

  setIsDirtySummary() {
    const v = this.modifiedVulnerability();
    this.isDirtySummary = !!(v && v.summary && v.summary.content);
  }

  setIsDirtyDescription() {
    const v = this.modifiedVulnerability();
    this.isDirtyDescription = !!(v && v.description && v.description.content);
  }

  setIsDirtyBusinessImplication() {
    const v = this.modifiedVulnerability();
    this.isDirtyBusinessImplication = !!(
      v &&
      v.businessImplication &&
      v.businessImplication.content
    );
  }

  setIsDirtyCompliant() {
    const v = this.modifiedVulnerability();
    this.isDirtyCompliant = !!(v && v.compliant && v.compliant.content);
  }

  setIsDirtyNonCompliant() {
    const v = this.modifiedVulnerability();
    this.isDirtyNonCompliant = !!(
      v &&
      v.nonCompliant &&
      v.nonCompliant.content
    );
  }

  setIsDirtySuccessMessage() {
    const v = this.modifiedVulnerability();
    this.isDirtySuccessMessage = !!(
      v &&
      v.successMessage &&
      v.successMessage.content
    );
  }

  setIsDirtyRelatedTo() {
    const v = this.modifiedVulnerability();
    this.isDirtyRelatedTo = !!(v && v.relatedTo && v.relatedTo);
  }

  cacheForCommit(name: string, value: string) {
    const mvs = localStorage.getItem("modifiedVulnerabilities");
    if (!mvs) {
      return;
    }
    const modifiedVulnerabilities = JSON.parse(mvs);
    if (!modifiedVulnerabilities[this.language]) {
      return;
    }
    const mv =
      modifiedVulnerabilities[this.language][this.langVulnerability.id];
    // const hashOrig = mv["hash"];
    const hashOrig = hash(mv.vulnerability);
    const hashCurr = hash(this.langVulnerability);

    if (hashCurr !== hashOrig) {
      const vs = localStorage.getItem("vulnerabilities");
      if (!vs) {
        return;
      }
      const vulnerabilities = JSON.parse(vs);
      const v = vulnerabilities[this.language][this.langVulnerability.id];
      if (!mv["vulnerability"]) {
        if (v[name].content !== value) {
          mv["vulnerability"] = {
            [name]: {
              content: value,
              updatedOn: new Date().toISOString()
            }
          };
        }
      } else if (!mv["vulnerability"][name]) {
        if (v[name].content !== value) {
          mv["vulnerability"][name] = {
            content: value,
            updatedOn: new Date().toISOString()
          };
        }
      } else if (mv["vulnerability"][name].content) {
        if (v[name].content === value) {
          delete mv["vulnerability"][name];
          if (Object.keys(mv["vulnerability"]).length == 0) {
            mv["vulnerability"] = null;
          }
        } else {
          mv["vulnerability"][name] = {
            content: value,
            updatedOn: new Date().toISOString()
          };
        }
      }
    } else {
      mv["vulnerability"] = null;
    }
    this.$store.commit("saveModifiedVulnerabilityField", {
      lang: this.language,
      id: this.langVulnerability.id,
      vulnerability: mv["vulnerability"]
    });
    localStorage.setItem(
      "modifiedVulnerabilities",
      JSON.stringify(modifiedVulnerabilities)
    );
    return;
  }

  cacheNameForCommit() {
    this.cacheForCommit("name", this.langVulnerability.name.content);
    this.setIsDirtyName();
    return;
  }
  cacheQuestionForCommit() {
    this.cacheForCommit("question", this.langVulnerability.question.content);
    this.setIsDirtyQuestion();
    return;
  }
  cacheSummaryForCommit() {
    this.cacheForCommit("summary", this.langVulnerability.summary.content);
    this.setIsDirtySummary();
    return;
  }
  cacheDescriptionForCommit() {
    this.cacheForCommit(
      "description",
      this.langVulnerability.description.content
    );
    this.setIsDirtyDescription();
    return;
  }
  cacheBusinessImplicationForCommit() {
    this.cacheForCommit(
      "businessImplication",
      this.langVulnerability.businessImplication.content
    );
    this.setIsDirtyBusinessImplication();
    return;
  }
  cacheCompliantForCommit() {
    this.cacheForCommit("compliant", this.langVulnerability.compliant.content);
    this.setIsDirtyCompliant();
    return;
  }
  cacheNonCompliantForCommit() {
    this.cacheForCommit(
      "nonCompliant",
      this.langVulnerability.nonCompliant.content
    );
    this.setIsDirtyNonCompliant();
    return;
  }
  cacheSuccessMessageForCommit() {
    this.cacheForCommit(
      "successMessage",
      this.langVulnerability.successMessage.content
    );
    this.setIsDirtySuccessMessage();
    return;
  }
  cacheRelatedToForCommit() {
    this.cacheForCommit("relatedTo", this.langVulnerability.relatedTo.content);
    this.setIsDirtyRelatedTo();
    return;
  }

  resetSession() {
    this.$store.commit("saveBranch", "");
    localStorage.removeItem("branch");
    this.$router.push({
      name: "vulnerability",
      params: {
        id: this.$route.params.id
      }
    });
  }
  reloadPage() {
    this.$router.go(0);
  }

  hasUpdates(field, enVulnerability, langVulnerability) {
    if (
      (enVulnerability && !enVulnerability[field].updatedOn) ||
      (langVulnerability && !langVulnerability[field].updatedOn)
    ) {
      return false;
    }
    if (
      new Date(enVulnerability[field].updatedOn) >
      new Date(langVulnerability[field].updatedOn)
    ) {
      return true;
    }
    return false;
  }

  getTitle(updatedOn = "") {
    if (!updatedOn) {
      return "";
    }
    return `Updated on ${dayjs(updatedOn).format("MMMM D, YYYY h:mm A")}`;
  }

  mounted() {
    this.checkDirtyFlags();
  }
}
